import React, { Component } from 'react';
import DocumentDownloadLink from '../../../components/document-download-link';

export default class OpinionFiles extends Component {
	renderAssetsList( assets, permalink, title ) {
		let sliced = assets.slice( 0, 3 );
		return (
			<ul className="assets-list opinions-toggle-list">
				{ sliced.map( asset => {
					return (<li key={ asset.id }>
							<DocumentDownloadLink link={ asset.link } title={ asset.title } />
						</li>
					);
				} ) }

				{ this.renderViewAll( sliced.length, assets.length, permalink, title ) }
			</ul>
		);
	}

	renderViewAll( slicedLength, assetsLength, permalink, title ) {
		if ( slicedLength < assetsLength ) {
			return (
				<li><a className="see-all" href={ permalink }>View all documents
					<span className="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
					<span className="sr-only" dangerouslySetInnerHTML={ { __html: ' for ' + title } }/>
				</a>
				</li>
			);
		}
	}

	render() {
		const files = this.props.files,
		      title = this.props.title.rendered;

		return (<div className="col-sm-4 opinion-files">
				<h4 className="assets-list-title">Documents ({ files.length })
					<span className="sr-only" dangerouslySetInnerHTML={ { __html: ' for ' + title } }/></h4>

				{ this.renderAssetsList( files, this.props.permalink, title ) }
			</div>
		);
	}
}